module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body"
  }, [_c('Hero', {
    attrs: {
      "imageName": "American-Credit-Asset-based-loans.png",
      "altText": "American Credit Asset based loans"
    }
  }, [
    [_c('h1', [_vm._v("American Credit® equipment financing")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          this.window.location.href = '/get-start'
        }
      }
    }, [_vm._v("\n        Apply Now\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Need equipment finance or other asset-based loans? Try us now. See how\n        we get you the money fast.\n        "), _c('a', {
      attrs: {
        "href": "/get-start"
      }
    }, [_vm._v("Get Started "), _c('i', {
      staticClass: "fa fa-long-arrow-right"
    })])])]
  ], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("How American Credit works for you?")]), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-p"
  }, [_vm._v("\n        We know you want to stay focused on your business instead of\n        burdensome applications or worrying about hidden costs. So we do the\n        heavy lifting and bring the fast business loan to you.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-title"
  }, [_vm._v("Here’s how it works")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-title"
  }, [_vm._v("See our process")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("\n          Apply Now\n        ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row user-feedback"
  }, [_c('div', {
    staticClass: "col-2 col-lg-4",
    staticStyle: {
      "background-color": "#00234d"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 col-lg-8",
    staticStyle: {
      "background-color": "#f6f9ff"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container row user-feedback-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "\n            col-10\n            offset-2\n            col-lg-5\n            offset-lg-0\n            user-feedback-content-right\n          "
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/quote.png"),
      "alt": "American Credit Equipment Financing Customer Vioce Quote"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "user-feedback-text"
  }, [_vm._v("\n            Banks don’t understand how fleeting opportunities are. With a loan\n            right now, we could upgrade our equipment and easily handle all\n            the new business.\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "user-feedback-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = 'tel:1855-904-0188'
      }
    }
  }, [_vm._v("\n              Let’s Talk\n            ")]), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform how-works"
  }, [_vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "text-center how-works-p",
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("\n        Our loan application and approval process are all digital and online.\n        We are open 24/7/365.\n      ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row how-works-button"
  }, [_c('button', {
    staticStyle: {
      "background-color": "rgb(84, 86, 255)",
      "color": "#ffffff",
      "font-size": "16px",
      "font-weight": "700",
      "height": "53px",
      "width": "169px",
      "border-radius": "26.5px",
      "border": "none"
    },
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("\n          Apply Now\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 offset-lg-1",
    staticStyle: {
      "border-bottom": "1px solid #dcdcdc"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "container platform trust-us"
  }, [_c('div', {
    staticClass: "row trust-us-box"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 trust-us-inner-left"
  }, [_c('div', [_c('p', {
    staticClass: "trust-us-title"
  }, [_vm._v("\n              American Credit: the difference you can trust\n            ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "trust-us-button"
  }, [_c('button', {
    on: {
      "click": function($event) {
        this.window.location.href = '/get-start'
      }
    }
  }, [_vm._v("\n                Apply Now\n              ")]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _vm._m(11)])])]), _vm._v(" "), _vm._m(12)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#eff9ff"
    }
  }, [_c('div', {
    staticClass: "container new_bluebg benefits"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n        Maximize working capital with "), _c('br'), _vm._v("flexible asset-based loans\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center benefit-items"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_loans_Flexible_Terms.png"),
      "alt": "American Credit Business loans Flexible Terms"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Flexible terms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("12-72 months terms to fit your needs.")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Competitive_Rates.png"),
      "alt": "American Credit Business Loans Competitive Rates"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Affordable")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                  Asset/equipment loan rate is much lower than unsecured\n                  loans.\n                ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Tax_Benefits.png"),
      "alt": "American Credit Business Loans Tax Benefits"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Tax benefit")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("IRS 179 tax benefit or bonus depreciation"), _c('sup', [_vm._v("1")]), _vm._v(".")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 pt-2 benefit-item"
  }, [_c('div', {
    staticClass: "benefit-item-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Transparency.png"),
      "alt": "American Credit Business Loans Transparency"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Transparency")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                  Loan origination fee, monthly installments all specified\n                  clearly.\n                ")]), _vm._v(" "), _c('br')])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "75%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_apply_in_minutes.png"),
      "alt": "American Credit asset-based loans apply in minutes"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Apply in minutes")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  Complete your application through our mobile app, online, or\n                  call us.\n                ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_prequalify_promptly.jpg"),
      "alt": "American Credit asset-based loans get pre-approval"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Get pre-approval")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  American Credit will review your application immediately and\n                  make a decision on the same or the next day.\n                ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "border-radius": "10px",
      "box-shadow": "2px 4px 30px 0px rgba(236, 236, 236, 0.75)",
      "margin": "16px",
      "height": "calc(100% - 15px)",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "233px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "55%",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/american_credit_get_funded_fast.png"),
      "alt": "American Credit asset-based loans get funded fast"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-family": "Biotif",
      "color": "#272727",
      "font-size": "24px",
      "font-weight": "300"
    }
  }, [_vm._v("Get funded fast")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  Once the collaterals are qualified, fund reaches client's\n                  account within 24 hours.\n                ")]), _vm._v(" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row text-center flow-charm-container"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1 flow-charm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Process_Apply_and_Approved.png"),
      "alt": "American Credit Business Loans Process Apply and Approved"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Apply 80%-100% for a $50k purchase")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Loan_Process_Approved.png"),
      "alt": "American Credit Equipment Loan Process Approved"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Approved")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Loan_Process_Calendar.png"),
      "alt": "American Credit Equipment Loan Process Calendar"
    }
  }), _vm._v(" "), _c('p', [_vm._v("$40k-50k to seller lien recorded")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-3 flow-charm-item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Business_Loans_Process_Loan_Money.png"),
      "alt": "American Credit Business Loans Process Loan Money"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Loan paid off lien removed")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flow-charm-container"
  }, [_c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 what-you-need"
  }, [_c('h4', [_vm._v("Minimum qualifications")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("FICO 600+")]), _vm._v(" "), _c('li', [_vm._v("1+ years business tax return")]), _vm._v(" "), _c('li', [_vm._v("$150,000+ annual revenue")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-5 what-you-need"
  }, [_c('h4', [_vm._v("What you need to apply")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Your business basic information")]), _vm._v(" "), _c('li', [_vm._v("Recent 6 months bank statements")]), _vm._v(" "), _c('li', [_vm._v("Purchase order from equipment vendor")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 offset-lg-1 user-feedback-content-left"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Financing_Customer_Vioce.png"),
      "alt": "American Credit Equipment Financing Customer Vioce"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "user-feedback-name"
  }, [_c('span', {
    staticStyle: {
      "color": "#6d6d6d",
      "font-weight": "300"
    }
  }, [_vm._v("Drew Arcelay")]), _c('br'), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("President, South Field Construction Company")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "300"
    }
  }, [_vm._v("Try us now. ")]), _c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_vm._v("See how we get you the money fast. ")]), _c('span', {
    staticStyle: {
      "color": "#5456ff",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/get-start"
    }
  }, [_vm._v("Get Started "), _c('i', {
    staticClass: "fa fa-long-arrow-right"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n        Need equipment finance for "), _c('br'), _vm._v("your business?\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "160px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Financing_Loan_Limit_High.png"),
      "alt": "American Credit Equipment Financing Loan Limit High"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  We can help you finance up to 100% and $5,000,000 for your\n                  business.\n                ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "160px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Financing_Low_Rates.png"),
      "alt": "American Credit Equipment Financing Low Rates"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  Low rates, 12-72 months\n                ")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-lg-4 pt-2"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "160px"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "auto",
      "object-fit": "contain"
    },
    attrs: {
      "src": require("../assets/imgs/American_Credit_Equipment_Financing_Flexible_Terms.png"),
      "alt": "American Credit Equipment Financing Flexible Terms"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#828282",
      "font-size": "18px",
      "font-weight": "300",
      "line-height": "26px",
      "width": "260px",
      "margin": "auto"
    }
  }, [_vm._v("\n                  Flexible payment terms available\n                ")]), _vm._v(" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "trust-us-text",
    staticStyle: {
      "color": "#686868",
      "font-weight": "300"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("You work hard. We work hard. We share the same ethic.")]), _vm._v("\n              That’s why we go the extra mile to look at your situation and\n              see if we can help. Unlike some business credit lenders who\n              focus on FICO scores, we look at your business as a whole.\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "#3c3c3c",
      "font-weight": "700"
    }
  }, [_c('a', {
    attrs: {
      "href": "/contact-us"
    }
  }, [_vm._v("Feel free to contact us\n                    "), _c('i', {
    staticClass: "fa fa-long-arrow-right",
    staticStyle: {
      "color": "#5456ff"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-lg-5 trust-us-inner-right"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/Lei-li-formal.jpeg"),
      "alt": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-10 offset-lg-1"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "20px",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("\n            Footnote\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding-left": "15px"
    }
  }, [_c('li', {
    staticStyle: {
      "list-style": "decimal",
      "font-family": "Biotif",
      "font-weight": "400",
      "font-size": "14px"
    }
  }, [_vm._v("Please consult with a tax professional for qualification and details.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27bf9fd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/businessLoan.vue
// module id = 1957
// module chunks = 5